(function(angular) {
    'use strict';
    angular.module('wtUi.wtNotifications', ['ngSanitize', 'ngAnimate', 'pascalprecht.translate'])
           .config(wtNotificationsConfig);

    wtNotificationsConfig.injector = ['$animateProvider'];
    function wtNotificationsConfig($animateProvider) {
        $animateProvider.classNameFilter(/\bis-animated\b/);
    }
})(window.angular);
